import React, { lazy, Suspense, useRef } from 'react';
import cn from 'classnames';

import Loading from '../../Loading';

import styles from './styles.less';

const VideoPlayer = lazy(() => import('.'));

export const AsyncVideoPlayer = (props) => {
  const { width, height, className } = props;
  const ref = useRef(null);

  // for repeating format 16:9
  const possibleHeight = height ?? (ref.current?.width ? ref.current.width * 0.5625 : null);

  return (
    <Suspense
      fallback={
        <div ref={ref} style={{ width, height: possibleHeight }} className={cn(styles.loaderWrap, className)}>
          <Loading text="" />
        </div>
      }
    >
      <VideoPlayer {...props} />
    </Suspense>
  );
};
